import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../../../components/breadcrumb";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import CamisetasGrid from "../components/CamisetasGrid";
import CamisetasHeader from "../components/CamisetasHeader";

function Camisetas() {
    const [mode, setMode] = useState("rojiverde");

    useEffect(() => {
        document.title = "Camisetas";
    }, []);

    const baseToggleBtn =
        "relative z-10 flex-1 min-w-[140px] px-4 md:px-6 py-2.5 rounded-lg text-xs md:text-sm font-bold text-center uppercase tracking-wide transition-colors duration-200";

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-3 sm:px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/" },
                        { label: "Historia" },
                        { label: "Camisetas", isCurrent: true },
                    ]}
                    className="mb-4"
                />

                <div>
                    <div className="mb-6 md:mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                        <CamisetasHeader />

                        <div className="w-full md:w-auto md:ml-auto">
                            <div className="inline-flex w-full max-w-md flex-wrap p-1 bg-[#0f1f15] border border-white/10 rounded-xl shadow-2xl gap-1">
                                {[
                                    { id: "rojiverde", label: "Rojiverde" },
                                    { id: "alternativa", label: "Alternativa" },
                                ].map((option) => (
                                    <button
                                        key={option.id}
                                        type="button"
                                        onClick={() => setMode(option.id)}
                                        className={`${baseToggleBtn} ${mode === option.id ? "text-[#062a1a]" : "text-slate-400 hover:text-white"}`}
                                    >
                                        {mode === option.id ? (
                                            <motion.span
                                                layoutId="camisetas-mode-toggle-pill"
                                                transition={{ type: "spring", stiffness: 420, damping: 34 }}
                                                className="absolute inset-0 -z-10 rounded-lg bg-green-500"
                                            />
                                        ) : null}
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <CamisetasGrid mode={mode} />
                </div>
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Camisetas;
